import { type RouteRecordRaw } from 'vue-router'

export default Object.keys(
  import.meta.glob('./sections/*.vue'),
).flatMap<RouteRecordRaw>(path => {
  if (path.includes('Page')) return []
  const filename = path.slice(path.lastIndexOf('/') + 1, path.lastIndexOf('.'))
  const name = filename.toLowerCase()
  const component = () => import(`./sections/${filename}.vue`)
  return {
    name: `dev-classic-${name}`,
    path: name,
    component,
    meta: {
      pageName: name,
    },
  }
})
